// Example address segment

import { AddressErrors } from "./types";

// { "long_name": "Brooklyn", "short_name": "Brooklyn", "types": [ "sublocality_level_1", "sublocality", "political"] }
export function filterSegment(
  address?: google.maps.GeocoderAddressComponent[],
  keys?: string[]
) {
  return address?.find((segment) =>
    keys?.find((key) => segment?.types?.includes(key))
  );
}

export const initialAddressValues = {
  country: "",
  street_address: "",
  address_line_1: "",
  address_line_2: "",
  unit_number: "",
  locality: "",
  administrative_division_2: "",
  administrative_division_1: "",
  postal_code: "",
};

export const initialTouched = Object.keys(initialAddressValues).reduce(
  (acc, key) => ({ ...acc, [key]: false }),
  {}
);

export function isAddressErrors(error: unknown): error is AddressErrors {
  if (typeof error !== "object" || error === null) {
    return false;
  }

  return Object.values(error).every(
    (value) => typeof value === "string" || Array.isArray(value)
  );
}

// optionally validate region select only if subdivisions exist
// allows field to be skipped if any of these countires are selected (or country is empty:
export const countriesWithNoSubdivisions = [
  "AX",
  "AS",
  "AI",
  "AQ",
  "AW",
  "BM",
  "BV",
  "IO",
  "KY",
  "CX",
  "CC",
  "CK",
  "CW",
  "FK",
  "FO",
  "GF",
  "PF",
  "TF",
  "GI",
  "GP",
  "GU",
  "GG",
  "HM",
  "VA",
  "HK",
  "IM",
  "JE",
  "MO",
  "MQ",
  "YT",
  "MS",
  "NC",
  "NU",
  "NF",
  "MP",
  "PN",
  "PR",
  "RE",
  "BL",
  "MF",
  "PM",
  "SX",
  "GS",
  "SJ",
  "TK",
  "TC",
  "VG",
  "VI",
  "EH",
];
